import React, {useEffect, useState} from "react";

export const FilterSearchBar = ({
    allItems = [],
    field = "",
    className = "",
    placeholder = "",
    setFiltered = () => {},
}) => {
    const [value, setValue] = useState("");
    const filterItems = () => {
        const valueToLowerCase = value?.toLowerCase();

        if (!valueToLowerCase) {
            setFiltered(allItems);
        } else {
            const filtered = allItems?.filter(item => {
                const valueToCompare = item[field] || "";
                return valueToCompare.toLowerCase().includes(valueToLowerCase);
            });
            setFiltered(filtered);
        }
    };

    useEffect(() => {
        filterItems();
    }, [allItems, value]);

    return (
        <input
            type="text"
            className={`custom_searchbar form-control form-control-solid ${className}`}
            placeholder={placeholder}
            value={value}
            onChange={e => setValue(e.target.value)}
        />
    );
};
